import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.editPODisclaimerLabel.presenters.editablePODisclaimerLabelTextFieldPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Label item has been updated.',
  },
  errorFallback: {
    id: `${scope}.errorFallback`,
    defaultMessage: 'Failed to update the label.',
  },
})
